const blockInvalidCharNumberInput = (e: any, allowMinusChar = false) => {
  const charList = ["e", "E", "+"];
  if (!allowMinusChar) {
    charList.push("-");
  }
  return charList.includes(e.key) && e.preventDefault();
};

export default blockInvalidCharNumberInput;
